import DocumentStatusBadge from './DocumentStatusBadge.component';

export default DocumentStatusBadge;
